import { COMPONENTS_IDS } from "./modules/network/consts";

export const PAGE_PATH = Object.freeze({
  DASHBOARD: "/",
  SEARCH: "/search/",
  ALERTS: "/alerts/",
  YARA: "/yara/",
  YARA_TESTRUN: "ruleset/:rulesetId/testrun/",
  YARA_TESTRUN_REANALYZE: "ruleset/:rulesetId/testrun/:testrunId/",
  YARA_DETAILS: "ruleset/:rulesetId/details/",
  YARA_REPOSITORIES: "repositories/",
  URL: "/url/:url/",
  DOMAIN: "/domain/:domain/",
  IP: "/ip/:ip/",
  SAMPLES_DETAILS_CLOUD: ":hash",
  SAMPLES_DETAILS_LOCAL: ":hash/source/:sourceId",
  REDIRECT_SAMPLES_DETAILS: "/redirect/:hash/*",
  LOGIN: "/accounts/login/",
  ADMIN_LOGIN: "/admin/login/",
  PASS_RESET_REQUEST: "/accounts/password_reset/",
  PASS_RESET_FORM: "/accounts/reset/:uidb64/:token/",
  IMPORT: "/import/",
  GRAPH_MANAGER: "/graph/",
  FLEXIBLE_INTEL_FEED: "/flexible-intel-feed/"
});

export const NETWORK_THREAT_PATH = Object.freeze({
  URL_ANALYSIS: "analysis/url/",
  IP_ANALYSIS: "analysis/ip/",
  DOMAIN_ANALYSIS: "analysis/domain/",
  DETECTIONS: "detections/",
  INFRASTRUCTURE: "infrastructure/",
  RELATIONS: "relations/",
  SCREENSHOTS_AND_DOM: "analysis/url/screenshots_and_dom/",
  ATTRIBUTION_DATA: "attribution-data/",
  MALWARE_FAMILY_INSIGHTS: "malware-family-insights/"
});

export const CLOUD_SAMPLE_SUMMARY_PATH = Object.freeze({
  SAMPLE_SUMMARY_DETAILS: "sample_details/",
  SAMPLE_SUMMARY_ANALYSIS: "analysis_results/",
  SAMPLE_SUMMARY_MITRE: "mitre_attack/"
});

export const TICORE_PATH = {
  YARA: "ticore/classification/yara/"
};

export const SECTION_PATH = Object.freeze({
  SAMPLE_DETAILS_TICLOUD: "ticloud/",
  STATIC_INFO_FILE: "static/info/",
  STATIC_INFO_HASHES: "static/info/hashes/",
  STATIC_INFO_VALIDATION: "static/info/validation/",
  STATIC_MITRE: "static/mitre/",
  STATIC_CLASSIFICATION: "static/classification/",
  STATIC_INT_STRINGS: "static/interesting_strings/",
  STATIC_APP_DOS: "static/application/",
  STATIC_APP_FILE: "static/application/file_header/",
  STATIC_APP_OPTIONAL: "static/application/optional_header/",
  STATIC_APP_IMPORTS: "static/application/imports/",
  STATIC_APP_SECTIONS: "static/application/sections/",
  STATIC_APP_RESOURCES: "static/application/resources/",
  DYNAMIC_MITRE: "dynamic/mitre_attack/",
  DYNAMIC_MALWARE_CONF: "dynamic/malware_configurations/",
  DYNAMIC_NETWORK: "dynamic/network_analysis/",
  DYNAMIC_BEHAVIORAL: "dynamic/behavioral/",
  DYNAMIC_DROPPED_FILES: "dynamic/dropped_files/",
  DYNAMIC_SURICATA_ALERTS: "dynamic/suricata_alerts/",
  DYNAMIC_SIGMA: "dynamic/sigma_detections/",
  DYNAMIC_YARA: "dynamic/yara/",
  JOE_BEHAVIORAL: "joe/behavioral/",
  JOE_NETWORK: "joe/network_analysis/",
  JOE_DOMAINS: "joe/domains/",
  JOE_MUTEXES: "joe/mutex/",
  SIGNATURES: "dynamic/signatures/",
  SOURCES: "sources",
  SOURCES_TICLOUD: "sources/ticloud/",
  SOURCES_NETWORK: "sources/network-references/",
  SOURCES_RELATIONSHIPS: "sources/relationships/",
  SOURCES_UPLOADS: "sources/uploads/",
  FILE_VISUALIZATION: "file-visualization/",
  EXTRACTED_FILES: "extracted-files/",
  URL_PAYLOADS: "payloads/",
  COMMENTS: "comments/",
  RL_CLOUD_SANDBOX: "rl_dynamic_analysis",
  RHA: "rha",
  NETWORK_REFERENCES: "network_references",
  ATTRIBUTION_DATA: "attribution-data/"
});

export const ADMIN_PATH = Object.freeze({
  ADMIN_DASHBOARD: "admin/",
  TOKENS: "admin/authtoken/tokenproxy/",
  APPLICATIONS: "admin/authtoken/application/",
  USERS: "admin/authentication/user/",
  COMMENTS: "admin/discussion/comment/",
  UPLOADS: "admin/uploads/upload/",
  CONFIGURATION: "config/",
  FACTORY_RESET: "reset/",
  SYSTEM_STATUS: "status/",
  SYSTEM_UPDATE: "update/",
  REDUNDANCY_SYSTEM: "cluster/",
  INTEGRATIONS: "integrations/",
  USER_ROLES: "user-roles/",
  CONNECTORS: "connectors/",
  LICENSING: "licensing/"
});
